import React from 'react'

import { BoxCupom } from './styles'

import { useGlobalContext } from 'src/contexto/contextoGlobal'
import GImage from '../gImage'
import Link from 'next/link'
import { useWindowDimensions } from 'src/contexto/hooks/useWindowDimensions'

export default function BarraCupom() {
  const { width } = useWindowDimensions()
  const isMobile = width <= 1200

  const { bannerHeaderData } = useGlobalContext()

  if (!(bannerHeaderData?.data?.length > 0) || !bannerHeaderData.data[0].banner)
    return null

  const banner = bannerHeaderData.data[0].banner

  const isVisible =
    (isMobile && banner?.imagem_mobile) || (!isMobile && banner?.imagem_desktop)

  if (!isVisible) return <></>

  return (
    <Link
      href={banner?.link?.parametros?.url ?? ''}
      target={banner?.link?.parametros?.target ?? '_self'}
    >
      <BoxCupom>
        <GImage
          src={isMobile ? banner.imagem_mobile.url : banner.imagem_desktop.url}
          fill
          quality={99}
          priority={true}
          alt={banner.titulo}
          style={{ objectFit: 'cover' }}
        />
      </BoxCupom>
    </Link>
  )
}
